import AscIconDark from '@Resources/assets/icons/dark/sortAsc.svg';
import DescIconDark from '@Resources/assets/icons/dark/sortDesc.svg';
import AscIconLight from '@Resources/assets/icons/light/sortAsc.svg';
import DescIconLight from '@Resources/assets/icons/light/sortDesc.svg';
import { SortOrder } from '@Utils/helpers/sortingHelpers';
import {
    SvgIcon,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip,
} from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import IconButton from '@Components/IconButton/IconButton';
import IconBtnStyles from '@Components/IconButton/IconButton.scss';
import ProjectsApi from '@Data/projects/Api';
import { ViewProjectType } from '@Data/projects/Interfaces';
import { selectedSortOrderState } from '@Data/projects/Reducer';
import Styles from './ProjectSortingComponents.scss';

const SelectProjectSortOrder = (props) => {
    const selectedSortOrder: SortOrder = useSelector(selectedSortOrderState);

    const handleSelection = (value: SortOrder) => {
        ProjectsApi.setSortOrder(value);
    };

    return (
        <div
            id="project-sort-switch-container"
            className={Styles.pscSwitchContainer}
        >
            <div className={IconBtnStyles.iconBtnGroup}>
                <IconButton
                    id="project-sort-asc-btn"
                    icon={
                        <SvgIcon inheritViewBox>
                            {selectedSortOrder === SortOrder.ASC ? (
                                <AscIconLight />
                            ) : (
                                <AscIconDark />
                            )}
                        </SvgIcon>
                    }
                    onClick={() => handleSelection(SortOrder.ASC)}
                    isSelected={selectedSortOrder === SortOrder.ASC}
                    tooltip="sort ascending"
                />
                <IconButton
                    id="project-sort-desc-btn"
                    icon={
                        <SvgIcon inheritViewBox>
                            {selectedSortOrder === SortOrder.DESC ? (
                                <DescIconLight />
                            ) : (
                                <DescIconDark />
                            )}
                        </SvgIcon>
                    }
                    onClick={() => handleSelection(SortOrder.DESC)}
                    isSelected={selectedSortOrder === SortOrder.DESC}
                    tooltip="sort descending"
                />
            </div>
        </div>
    );
};

export default SelectProjectSortOrder;
